<template>
  <div>
    <!-- 打印按钮 -->
    <el-button type="primary" icon="el-icon-printer" @click="handlePrint" style="margin-bottom: 20px;">
      打印全部表单
    </el-button>

    <!-- 打印内容 -->
    <div id="print-container">
      <div v-for="(form, index) in tableData" :key="index" class="form-container" style="padding: 20px;padding-left: 0px;">
        <!-- 表单内容 -->
        <div class="print-content" style="padding: 20px;padding-top: 21px;">
          <!-- Header Section -->
          <div class="header" style="text-align: center; margin-bottom: 10px; position: relative;">
            <div style="margin: 0; font-size:18px;margin-top: -30px;">
              
              
              <el-input v-model="form.title" style="width: 400px;font-size: 16px; display: inline-block;"></el-input>

            </div>
            <div
              style="font-size: 12px; margin-top: 2px; position: absolute; right: 80px; top: 30px;"
            >
              单据编号: {{ form.order_code }}
            </div>
     
            <div
              style="font-size: 12px; margin-top: 2px; position: absolute; right: 50px; top: 0px; font-size: 12px;"
            >
              第{{ index + 1 }}/{{ tableData.length }}页
            </div>
          </div>

          <!-- Customer Info -->
          <div
            class="customer-info"
            style="margin-bottom: 10px; font-size: 12px; position: relative; margin-top:-22px;"
          >
            <div>单据日期: {{ form.order_date }}</div>
            <div style="">
              客&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;户:
              <el-input v-model="form.customer_name" style=" width: 400px;font-size: 12px; display: inline-block;"></el-input>
            </div>
            <div style="margin-top: 1px;">
              联系电话:
              <el-input v-model="form.phone" style="width: 150px; display: inline-block;"></el-input>
              <span style="margin-left: 20px;font-size: 14px;">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址:
                <el-input v-model="form.address" style="width: 320px; display: inline-block;"></el-input>
              </span>
            </div>
            <div style="margin-top: 1px;">
              公司地址:
              <el-input v-model="form.company_address" style="width: 400px; display: inline-block;"></el-input>
            </div>

            <div style="position: absolute; bottom: 0px; right: 30px;margin-top: 12px;">
              投诉与建议电话：{{ form.complaint_phone }}
            </div>
          </div>

          <!-- Table Section -->
          <table class="detail-table" style="width: 100%; border-collapse: collapse; font-size: 10px; margin-top: -8px;">
            <thead>
              <tr>
                <th style="border: 1px solid #000; padding: 2px; width: 5%;">行号</th>
                <th style="border: 1px solid #000; padding: 2px; width: 30%; ">商品全名</th>
                <th style="border: 1px solid #000; padding: 2px; width: 10%;">规格</th>
                <th style="border: 1px solid #000; padding: 2px; width: 10%;">商品ID</th>
                <th style="border: 1px solid #000; padding: 2px; width: 5%;">单位</th>
                <th style="border: 1px solid #000; padding: 2px; width: 5%;">数量</th>
                <th style="border: 1px solid #000; padding: 2px; width: 10%;">单价</th>
                <th style="border: 1px solid #000; padding: 2px; width: 10%;">金额</th>
                <th style="border: 1px solid #000; padding: 2px; width: 15%;">备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, itemIndex) in form.data" :key="itemIndex">
                <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ itemIndex + 1 }}</td>
                <td style="border: 1px solid #000; padding: 2px;">{{ item.product_name }}</td>
                <td style="border: 1px solid #000; padding: 2px;">{{ item.spec_value }}</td>
                <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ item.product_id }}</td>
                <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ item.unit }}</td>
                <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ item.total_num }}</td>
                <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ item.product_price }}</td>
                <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ item.total_pay_price }}</td>
                <td style="border: 1px solid #000; padding: 2px;">{{ item.remarks }}</td>
              </tr>

              <tr>
                <!-- 合并前两列 -->
                <td colspan="2" style="border: 1px solid #000; padding: 2px; text-align: center;">
                  一联（白）回单；二联（红）客户
                </td>
                <!-- 保留空列 -->
                <td style="border: 1px solid #000; padding: 2px;"></td>
                <td style="border: 1px solid #000; padding: 2px;"></td>
                <td style="border: 1px solid #000; padding: 2px; text-align: center;">数量</td>
                <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ form.all_num }}</td>
                <td style="border: 1px solid #000; padding: 2px; text-align: center;">金额</td>
                <!-- 合并两列 -->
                <td colspan="2" style="border: 1px solid #000; padding: 2px; text-align: center;">
                  {{ form.all_price }} 元
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Footer Notes -->
          <!-- <div class="footer-notes" style="margin-top: 2px; font-size: 14px; margin-left: 2px;">
            <p>货物当天请验收清楚，如有问题请联系业务员，非质量问题谢绝退换，敬请谅解，谢谢合作！</p>
            <p>配送箱可重复使用，麻烦各位客户朋友下次配送时可收回，谢谢！！！</p>
          </div> -->
        </div>

        <!-- 分页标记 -->
        <div class="page-break"></div>
      </div>
    </div>
  </div>
</template>
  
  <script>
   import DdeliveryApi from '@/api/ddelivery.js';
  export default {
    data() {
      return {
        curPage:10,
        formInline:{
          store_id:0,
          id:0,
        },
        // 示例表单数据
        tableData: [],
      };
    },
    created() {
      this.formInline.id = this.$route.query.id;
      /*获取列表*/
      this.getTableList();
    },
    methods: {
       /*获取列表*/
       getTableList() {
          let self = this;
          let Params = this.formInline;
          Params.page = self.curPage;
          self.loading = true;
          DdeliveryApi.listp(Params, true)
            .then(data => {
              self.loading = false;
              self.tableData = data.data;
              for(var i=0;i<self.tableData.length;i++){
                self.tableData[i].title = '宁心仓销售货单'
              }
            })
            .catch(error => {
            });
        },

      // 打印功能
      handlePrint() {
        const printContent = document.getElementById("print-container").cloneNode(true); // 克隆打印区域
        const inputs = printContent.querySelectorAll("input"); // 获取所有输入框

        // 将输入框替换为它们的值
        inputs.forEach(input => {
          const span = document.createElement("span");
          span.textContent = input.value;
          input.parentNode.replaceChild(span, input);
        });

        const printWindow = window.open(""); // 打开新窗口
        printWindow.document.write(`
          <html>
            <head>
        
              <style>
                body {
                  font-family: Arial, sans-serif;
                  margin: 0px;
                }
                table {
                  width: 100%;
                  border-collapse: collapse;
                }
                th, td {
                  border: 1px solid #000;
                  padding: 2px;
                  text-align: center;
                }
                .page-break {
                  page-break-after: always; /* 每个表单分开一张纸 */
                }
              </style>
            </head>
            <body>
              ${printContent.innerHTML} <!-- 填充打印内容 -->
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.print(); // 执行打印
      },
    },
  };
  </script>
  
  <style>

  @page {
      size: auto;
      margin: 0; /* 移除默认页边距 */
    }

    /* 隐藏页眉页脚（浏览器兼容性有限） */
    @media print {
      @page { 
        margin: 0; 
      }
      body { 
        margin: 1.6cm; /* 控制内容区域位置 */
      }
    }

  .print-container {
    font-family: Arial, sans-serif;

  }


  .form-container{
    width: 80%;
    margin: 0 auto;
    padding: 10px;
    border: 1px dashed #000;
  }
  .header {
    position: relative;
    text-align: center;
    margin-bottom: 20px;
  }
  .detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  .detail-table th,
  .detail-table td {
    border: 1px solid #000;
    padding: 8px;
    text-align: center;
    font-size: 12px;
  }
  .footer-notes {
    margin-top: 40px;
    font-size: 12px;
    text-align: left;
    line-height: 1.5;
  }
  .page-break {
    page-break-after: always; /* 分页标记 */
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/order/order/genorder.vue